// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2hBlH","content":"styles_content__3XZbA","checkbox":"styles_checkbox___7TJC","checkboxLabel":"styles_checkboxLabel__g_WJs"};